import React from "react";
import { Link } from "react-router-dom";
import { EnvelopeSimple } from "@phosphor-icons/react";

export const Footer = ({ dark = true }) => {
  const base = dark
    ? "bg-[#0a192f] text-slate-400 border-t border-white/10"
    : "bg-slate-50 text-slate-500 border-t border-slate-200";
  return (
    <footer className={`${base} py-10 mt-8`}>
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <img
            src="/branding/loadwise-logo-192.png"
            alt="LoadWise"
            className="h-8 w-auto"
            draggable="false"
          />
          <span className="text-sm font-medium text-slate-300">LoadWise</span>
        </div>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs">
          <Link to="/privacy" data-testid="footer-privacy" className="hover:text-white">Privacy</Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-white">Terms</Link>
          <Link to="/refund" data-testid="footer-refund" className="hover:text-white">Refund policy</Link>
          <a
            href="mailto:support@loadwise.app"
            data-testid="footer-support"
            className="hover:text-white inline-flex items-center gap-1.5"
          >
            <EnvelopeSimple size={12} weight="bold" />
            support@loadwise.app
          </a>
        </nav>
        <p className="text-[11px] tabular">© {new Date().getFullYear()} LoadWise</p>
      </div>
    </footer>
  );
};
